import { ReactNode } from 'react';

import { SemenAppProvider } from './SemenAppContext';

type SemenAppWrapperProps = {
  children: ReactNode;
};

export const SemenAppWrapper = ({ children }: SemenAppWrapperProps) => {
  return <SemenAppProvider>{children}</SemenAppProvider>;
};
